import {
  BaseRequestPolicy,
  HttpOperationResponse,
  RequestPolicy,
  RequestPolicyFactory,
  RequestPolicyOptions,
  WebResourceLike,
} from '@azure/core-http';
import { pageDataService } from '../common/utilities/PageDataService';
import { getCookie } from '../common/utilities/Cookie';

export class TelemetryClientHeaderPolicy extends BaseRequestPolicy {
  constructor(nextPolicy: RequestPolicy, requestPolicyOptions: RequestPolicyOptions) {
    super(nextPolicy, requestPolicyOptions);
  }

  async sendRequest(request: WebResourceLike): Promise<HttpOperationResponse> {
    var isWebView = pageDataService.isWebView();
    var clientUserAgentHeaderName = 'Client-User-Agent';
    request.headers.set('IsWebView', isWebView.toString());
    if (!isWebView) {
      request.headers.set(clientUserAgentHeaderName, 'Platform/Web');
    } else {
      request.headers.set(clientUserAgentHeaderName, getCookie(clientUserAgentHeaderName));
    }
    return await this._nextPolicy.sendRequest(request);
  }
}

export const telemetryClientHeaderPolicy: () => RequestPolicyFactory = () => ({
  create: (nextPolicy: RequestPolicy, options: RequestPolicyOptions) => new TelemetryClientHeaderPolicy(nextPolicy, options),
});
